import React, { useState, useEffect } from "react";
import { Table, Card, Badge, Image, Button, Modal } from "react-bootstrap";
import { FaBook, FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
function OrderList() {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const [orderList, setOrderList] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrderList();
  }, []);

  const fetchOrderList = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/user-order-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: Number(user_id) }),
        }
      );

      if (!res.ok) throw new Error("Failed to fetch orders");

      const data = await res.json();
      if (data.status === "1" && Array.isArray(data.data)) {
        setOrderList(data.data);
        setImagePath(data.imagePath || "");
      } else {
        console.warn("Unexpected response structure or empty data");
        setOrderList([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setOrderList([]);
    }
  };

  const getStatusBadge = (status) => {
    if (!status || typeof status !== "string") {
      return <Badge bg="secondary" className="w-100">Unknown</Badge>;
    }
    switch (status.toLowerCase()) {
      case "completed":
        return <Badge bg="success" className="w-100">Completed</Badge>;
      case "pending":
        return <Badge bg="warning" className="w-100" text="dark">Pending</Badge>;
      case "cancelled":
        return <Badge bg="danger" className="w-100">Cancelled</Badge>;
      default:
        return <Badge bg="secondary" className="w-100">{status}</Badge>;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };


  const handleShowDetails = (order) => {
    setSelectedOrder(order);
    setShowDetailsModal(true);
  };

  const handleCloseDetails = () => {
    setShowDetailsModal(false);
    setSelectedOrder(null);
  };

  return (
    <Card className="shadow border-0">
      <Card.Header className="bg-primary text-white fw-semibold">
        <FaBook className="me-2" />
        My Order List
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover responsive>
          <thead className="table-success">
            <tr>
              <th>Sr.No.</th>
              <th>Order ID</th>
              <th>Items</th>
              <th>image</th>
              <th>Total Amount</th>
              <th>Order Date</th>
              <th>Status</th>
              <th>Order Detail</th>
            </tr>
          </thead>
          <tbody>
            {orderList && orderList.length > 0 ? (
              orderList.map((order, index) => (
                <tr key={order.id}>
                  <td>{index + 1}</td>
                  <td>{order.id}</td>
                  <td>
                    {order.items && order.items.length > 0 ? (
                      <div>
                        {order.items.map((item, idx) => (
                          <div key={item.id}>
                            {item.title} (Qty: {item.quantity})
                          </div>
                        ))}
                      </div>
                    ) : (
                      "No items"
                    )}
                  </td>
                  <td>
                    {order.items && order.items.length > 0 ? (
                      <div>
                        {order.items.map((item, idx) => (
                          <div key={item.id} className="d-flex align-items-center mb-2">
                            {item.image && (
                              <Image
                                src={`${imagePath}${item.image}`}
                                alt={item.title}
                                thumbnail
                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/50x50?text=No+Image';
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      "No items"
                    )}
                  </td>
                  <td>₹{order.total_amount}</td>
                  <td>{formatDate(order.created_at)}</td>
                  <td>{getStatusBadge(order.status)}</td>
                  <td>
                    <FaEye
                      role="button"
                      style={{ cursor: "pointer", color: "#ff5f1f" }}
                      onClick={() => handleShowDetails(order)}
                    />
                  </td>


                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No Orders Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Modal show={showDetailsModal} onHide={handleCloseDetails} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Order Details #{selectedOrder?.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder && (
              <div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h6>Order Information</h6>
                    <p><strong>Order ID:</strong> #{selectedOrder.id}</p>
                    <p><strong>Order Date:</strong> {formatDate(selectedOrder.created_at)}</p>
                    <p><strong>Status:</strong> {getStatusBadge(selectedOrder.status)}</p>
                    <p><strong>Total Amount:</strong> ₹{selectedOrder.total_amount}</p>
                  </div>
                  <div className="col-md-6">
                    <h6>Payment Information</h6>
                    <p><strong>Payment ID:</strong> {selectedOrder.razorpay_payment_id || 'N/A'}</p>
                    <p><strong>Order ID:</strong> {selectedOrder.razorpay_order_id || 'N/A'}</p>
                    <p><strong>Receipt:</strong> {selectedOrder.receipt || 'N/A'}</p>
                  </div>
                </div>

                <h6>Shipping Address</h6>
                <div className="card p-3 mb-3">
                  <p>
                    <FaMapMarkerAlt className="me-2 text-danger" />
                    {selectedOrder.address_line1}
                    {selectedOrder.address_line2 && <>, {selectedOrder.address_line2}</>}
                  </p>
                  <p>
                    {selectedOrder.city}, {selectedOrder.state} - {selectedOrder.pincode}
                  </p>
                  <p>{selectedOrder.country}</p>
                </div>

                <h6>Ordered Products</h6>
                <Table striped bordered size="sm">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.items && selectedOrder.items.length > 0 ? (
                      selectedOrder.items.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              {item.image && (
                                <Image
                                  src={`${imagePath}${item.image}`}
                                  alt={item.title}
                                  thumbnail
                                  style={{ width: '40px', height: '40px', objectFit: 'cover', marginRight: '10px' }}
                                />
                              )}
                              <div>{item.title}</div>
                            </div>
                          </td>
                          <td>₹{item.price}</td>
                          <td>{item.quantity}</td>
                          <td>₹{item.price * item.quantity}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">No items</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetails}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
}

export default OrderList;